module.exports = __webpack_public_path__ + "media/images/signups/card/admin-card-34ba1e8eae1535daf46495e3ebddff70.png";